// @flow
/**
 * constants for paypal features
 */
export const BUY = 'buy'
export const GIFT = 'gift'
export const INVOICE = 'invoice'
export const MASS_PAYMENT = 'massPayment'
export const PIX = 'pix'
export const POOLS = 'pools'
export const PPME = 'ppme'
export const SELLER = 'seller'
export const REQUEST = 'request'
export const SEND = 'send'
export const XB = 'xb'
export const XB_BIZ = 'xbBiz'
export const REQUEST_GROUP = 'requestGroup'
export const SPLIT = 'split'
export const PPDG = 'ppdg'
export const MGM = 'mgm'
export const DONATION = 'donation'
export const MESSAGES = 'messages'
export const VISA_PLUS = 'visaPlus'
